import React, { useEffect, useState } from "react";
import { Check, RefreshCw, ShieldCheck } from "lucide-react";
import { approveUser, getPendingUsers } from "../services/api";

const AdminUsers = () => {
    const [pendingUsers, setPendingUsers] = useState([]);
    const [statusMessage, setStatusMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const loadPendingUsers = async () => {
        setIsLoading(true);
        try {
            const { data } = await getPendingUsers();
            setPendingUsers(data);
        } catch (err) {
            setStatusMessage(err.response?.data?.detail || "Could not load pending users");
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        loadPendingUsers();
    }, []);

    const handleApprove = async (userId) => {
        try {
            await approveUser(userId);
            setPendingUsers((users) => users.filter((user) => user.id !== userId));
            setStatusMessage("User approved");
        } catch (err) {
            setStatusMessage(err.response?.data?.detail || "Could not approve user");
        }
    };

    return (
        <main className="admin-shell">
            <header className="admin-header">
                <div>
                    <span className="eyebrow">Administration</span>
                    <h1>User approvals</h1>
                </div>
                <button className="icon-action" onClick={loadPendingUsers} disabled={isLoading} title="Refresh">
                    <RefreshCw size={16} />
                </button>
            </header>

            <section className="admin-panel">
                {pendingUsers.length === 0 ? (
                    <div className="empty-state">
                        <ShieldCheck size={28} />
                        <p>No users are waiting for approval.</p>
                    </div>
                ) : (
                    pendingUsers.map((user) => (
                        <div className="admin-user-row" key={user.id}>
                            <div>
                                <strong>{user.username}</strong>
                                <span>{user.email}</span>
                            </div>
                            <span className="status-pill">{user.account_status}</span>
                            <button onClick={() => handleApprove(user.id)}>
                                <Check size={16} />
                                Approve
                            </button>
                        </div>
                    ))
                )}
            </section>

            {statusMessage && <p className="call-notice">{statusMessage}</p>}
        </main>
    );
};

export default AdminUsers;
